export default class ClienteApp {
    constructor(){
        this.id = null,
        this.clienteApp = '',
        this.nome = '',
        this.detalhes = '',
        this.login = '',
        this.dataUltimoRefresh = null;
    }

}